
















import { Vue, Component } from "vue-property-decorator";

interface ColorItem {
  label: string;
  hex: string;
  variable: string;
}

@Component({})
export default class Colors extends Vue {
  private colors: ColorItem[] = [
    {
      label: "Text",
      hex: "#545960",
      variable: "$text-color",
    },
    {
      label: "Dark",
      hex: "#282828",
      variable: "$dark",
    },
    {
      label: "Text muted",
      hex: "#B3B6BE",
      variable: "$text-muted",
    },
    {
      label: "Primary",
      hex: "#8DC53F",
      variable: "$primary",
    },
    {
      label: "Gray-400",
      hex: "#E1E2E5",
      variable: "$gray-400",
    },
    {
      label: "Primary dark",
      hex: "#72A130",
      variable: "$primary-dark",
    },
    {
      label: "Gray-200",
      hex: "#F4F4F6",
      variable: "$gray-200",
    },
    {
      label: "Danger",
      hex: "#F34852",
      variable: "$danger",
    },
    {
      label: "Gray-100",
      hex: "#FAFAFA",
      variable: "$gray-100",
    },
    {
      label: "Danger DARK",
      hex: "#C80D18",
      variable: "$danger-dark",
    },
  ];
}
